"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditableDropdown = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _Dropdown = require("../Dropdown");
var _InputText = require("../../InputText");
var _EditModeToggle = require("../../Buttons/EditModeToggle");
var _propTypes = require("../../../../../propTypes");
require("./editableDropdown.scss");
const _excluded = ["editMode", "toggleButton", "includeEmptyOption", "options", "useOptionTrigger", "optionTrigger"],
  _excluded2 = ["customChangeHandler"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const EditableDropdown = _ref => {
  let {
      editMode = false,
      toggleButton = {
        customCssClass: '',
        editMode: {
          label: 'Pick from the provided list',
          icon: 'reorder'
        },
        defaultMode: {
          label: 'Enter a new option that is not available in the provided list',
          icon: 'pencil'
        }
      },
      includeEmptyOption,
      options,
      useOptionTrigger = false,
      optionTrigger = {
        label: 'Other',
        value: 'other',
        appendOption: true
      }
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const [showTextInput, setShowTextInput] = (0, _react.useState)(editMode);
  const hasOptionTrigger = useOptionTrigger && typeof optionTrigger !== 'undefined';
  const {
      customChangeHandler
    } = otherProps,
    rest = _objectWithoutProperties(otherProps, _excluded2);
  const HandleOptionSelect = event => {
    const selectedOption = event.target.value;
    if (hasOptionTrigger && (selectedOption === optionTrigger.label || selectedOption === optionTrigger.value)) {
      setShowTextInput(true);
    }
    if (customChangeHandler) {
      customChangeHandler(selectedOption);
    }
  };
  const GetDropdownOptions = () => {
    if (hasOptionTrigger && optionTrigger.appendOption) {
      const {
        label,
        value
      } = optionTrigger;
      if (typeof options[0] === 'string') {
        return [...options, optionTrigger.label];
      }
      return [...options, {
        label,
        value
      }];
    }
    return options;
  };
  const HandleEditModeChange = newState => {
    setShowTextInput(newState);
  };
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "formField editableDropdownField ".concat(rest.customCssClass || '')
  }, showTextInput ? /*#__PURE__*/_react.default.createElement(_InputText.InputText, rest) : /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, _objectSpread({
    includeEmptyOption,
    options: GetDropdownOptions(),
    customChangeHandler: HandleOptionSelect
  }, rest)), (!hasOptionTrigger || hasOptionTrigger && showTextInput) && /*#__PURE__*/_react.default.createElement(_EditModeToggle.EditModeToggle, {
    editMode: showTextInput,
    toggleButton,
    onEditModeChange: HandleEditModeChange
  }));
};
exports.EditableDropdown = EditableDropdown;
EditableDropdown.propTypes = _objectSpread(_objectSpread({}, _propTypes.DropdownPropTypes), _EditModeToggle.EditModeTogglePropTypes);
EditableDropdown.defaultTypes = _propTypes.FormFieldDefaultProps;
var _default = exports.default = EditableDropdown;